module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/plan-9edd7388598980069a9d5178428097ac.svg";